module.exports = __webpack_public_path__ + "img/1-1.8e5a7262.svg";